import type { Upgrade } from "./types";

export const UPGRADE_CARDS: ReadonlyArray<Upgrade> = [
  {
    id: "market_blessing_105",
    scope: "session",
    target: "trade",
    trigger: "trade_close_win",
    effects: [{ op: "profit_mult", value: 1.05 }],
    stacking: { stack_mode: "mult", stack_cap: { profit_mult: 1.2 } },
  },
  {
    id: "diamond_5s_115",
    scope: "session",
    target: "trade",
    trigger: "trade_close_win",
    condition: (c) => (c.numbers.holdMs ?? 0) >= 5000,
    effects: [{ op: "profit_mult", value: 1.15 }],
  },
  {
    id: "yield_hold_03",
    scope: "session",
    target: "trade",
    trigger: "trade_close_win",
    effects: [{ op: "profit_add_per_sec", pct: 0.003 }],
  },
  {
    id: "scalper_2s_105",
    scope: "session",
    target: "trade",
    trigger: "trade_close_win",
    condition: (c) => (c.numbers.holdMs ?? 0) < 2000,
    effects: [{ op: "profit_mult", value: 1.05 }],
  },
  {
    id: "paper_fee_05",
    scope: "session",
    target: "trade",
    trigger: "first_loss",
    effects: [
      { op: "loss_nullify" },
      { op: "trade_fee_pct", buy: 0.005, sell: 0.005 },
    ],
    limits: { once_per: "round" },
  },
  {
    id: "panic_shield_10",
    scope: "session",
    target: "trade",
    trigger: "threshold_loss_10",
    effects: [{ op: "loss_nullify" }],
    limits: { once_per: "round" },
  },
  {
    id: "soft_stop_fee_05",
    scope: "session",
    target: "trade",
    trigger: "trade_close_loss",
    effects: [
      { op: "loss_reduction_pct", pct: 0.2 },
      { op: "trade_fee_pct", buy: 0.005, sell: 0.005 },
    ],
  },
  {
    id: "halve_first_loss",
    scope: "session",
    target: "trade",
    trigger: "first_loss",
    effects: [{ op: "loss_reduction_pct", pct: 0.5 }],
    limits: { once_per: "round" },
  },
  {
    id: "first_win_130",
    scope: "session",
    target: "trade",
    trigger: "first_win",
    effects: [{ op: "profit_mult", value: 1.3 }],
    limits: { once_per: "round" },
  },
  {
    id: "moonshot_20_130_fee_05",
    scope: "session",
    target: "trade",
    trigger: "threshold_win_20",
    effects: [
      { op: "profit_mult", value: 1.3 },
      { op: "trade_fee_pct", buy: 0.005, sell: 0.005 },
    ],
  },
  {
    id: "time_plus_10",
    scope: "session",
    target: "round",
    trigger: "round_start",
    effects: [{ op: "round_time_add_sec", value: 10 }],
  },
  {
    id: "buys_plus_3",
    scope: "session",
    target: "round",
    trigger: "round_start",
    effects: [{ op: "round_buys_add", value: 3 }],
  },
  {
    id: "lever_3x_liqN",
    scope: "session",
    target: "trade",
    trigger: "trade_open",
    effects: [
      { op: "leverage_mult", value: 3.0 },
      { op: "auto_liquidate_at_drawdown_pct", pct: 12 },
    ],
  },
  {
    id: "achieve_30_upgrade",
    scope: "session",
    target: "account",
    trigger: "threshold_win_30",
    effects: [{ op: "upgrade_random_card", count: 1 }],
  },
  {
    id: "achieve_20_bonus5",
    scope: "session",
    target: "account",
    trigger: "threshold_win_20",
    effects: [{ op: "bonus_holdings_pct", pct: 0.05 }],
  },
  {
    id: "next_first_win_x2",
    scope: "this_round",
    target: "trade",
    trigger: "first_win",
    effects: [{ op: "profit_mult", value: 2.0 }],
    limits: { once_per: "round" },
  },
];

export function getThreeRandomCards(): ReadonlyArray<Upgrade> {
  const pool = [...UPGRADE_CARDS];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, 3);
}
